import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { IBaseDisbursementType } from '../IBaseDisbursementType';
import { defaultCreate } from '../defaultCreate';
import { WireDisbursementContainer } from './WireDisbursementContainer';
import { WireStatusPill } from './WireStatusPill';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { IDisbursementFormData } from 'types/order/escrow/IDisbursementFormData';

export interface IWireDisbursementType extends IBaseDisbursementType<eDisbursementType.Wire> { }

export const WireDisbursementType: IWireDisbursementType = {
  type: eDisbursementType.Wire,

  editPermission: ePermissions.EscrowWireDisbursementsEdit,
  readPermission: ePermissions.EscrowWireDisbursementsRead,

  create: (fee, order, isSpruceWithZillowEnabled, isZillowClosing) => {
    return {
      ...defaultCreate(fee, order, isSpruceWithZillowEnabled, isZillowClosing),
      type: eDisbursementType.Wire,
      holdback: false,
      holdbackProperties: {},
    };
  },
  container: WireDisbursementContainer,
  statusPill: WireStatusPill,
  isReadOnly: (x: IDisbursementFormData) => {
    if (x.type === eDisbursementType.Wire) {
      return !!x.enqueuedForDisbursementAt || !!x.sendAt;
    }
    return true;
  },
};
